import { render } from "./InputCheckboxMultiSelect.vue?vue&type=template&id=016601c5&scoped=true&ts=true"
import script from "./InputCheckboxMultiSelect.vue?vue&type=script&lang=ts"
export * from "./InputCheckboxMultiSelect.vue?vue&type=script&lang=ts"

import "./InputCheckboxMultiSelect.vue?vue&type=style&index=0&id=016601c5&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/bouwstenen/Bouwsteen_BuildAndDeploy_Vue_Frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-016601c5"]])

export default __exports__